import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type CreateActivityTagSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function CreateActivityTagSuccessModal({ isOpen, handleClose }: CreateActivityTagSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="create-activity-tag-success">
      <AcknowledgeModal
        result="positive"
        title={t('typography.activityTagCreatedTitle')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="create-activity-tag-success-modal-btn"
      >
        {t('typography.activityTagCreatedDescription')}
      </AcknowledgeModal>
    </Modal>
  )
}
